<template>
    <div>
        <div class="w-1200 nav">
            <img src="../../assets/home_1.png">
            <span class="margin-left-8"><el-link type="info" @click="gohome">首页</el-link></span>
            <span class="margin-left-8" v-if="this.$store.state.homeNavValue !== '首页'"> > </span>
            <span class="margin-left-8" v-if="this.$store.state.homeNavValue !== '首页'"><el-link type="info" @click="goback">{{ this.$store.state.homeNavValue }}</el-link></span>
        </div>
        <div class="w-1200 bg">
            <div class="art-title">{{ artList.title }}</div>
            <div class="art-source">文章来源：{{ artList.publisher }} 发布时间：{{ artList.publishtime }}</div>
            <div class="art-line"></div>
            <div class="art-content" v-html="artList.content"></div>
        </div>
    </div>
</template>

<script>
    import api from '../../model/api';

    export default {
        name: 'art',
        components: {},
        props: {},
        data () {
            return {
                params: {},
                artList: {}
            };
        },
        watch: {},
        computed: {
            nowNav () {
                if (this.$store.state.homeNavValue) {
                    return '首页' + ' > ' + this.$store.state.homeNavValue
                } else {
                    return '首页' + ' > ' + '正文'
                }
            }
        },
        methods: {
            getActivtyNews(id){
                console.log(id)
                let vars = {};
                vars.params = {
                    id: id
                };
                api.webgetdetail(vars, this, data => {
                    console.log(data)
                    this.artList = data.data
                })
            },
            gohome () {
                this.$router.push({
                    name: 'home'
                })
            },
            goback () {
                this.$router.go(-1)
            }
        },
        created () {
        },
        mounted () {
            console.log(this.$store.state,'state')
            if (this.$route.query.id) {
                this.getActivtyNews(this.$route.query.id);
            }
        }
    };
</script>

<style scoped>
.bg{
    background:rgba(242,242,242,1);
    padding-top: 42px;
    min-height: 800px;
    display: flex;
    flex-direction: column;
    align-items: center;
}
    .art-title{
        font-size:26px;
        font-weight:400;
        color:rgba(51,51,51,1);
    }
    .art-source{
        font-size:16px;
        font-weight:400;
        color:rgba(131,131,131,1);
        margin-top: 19px;
    }
    .art-line{
        width:1120px;
        height:1px;
        background:rgba(191,191,191,1);
        margin-top: 29px;
    }
    .art-content{
        width:1120px;
        line-height: 30px;
        padding: 50px;
        font-family: 宋体;
    }
    .nav{
        text-align: left;
        height: 35px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    .nav-bran{

    }
</style>



// WEBPACK FOOTER //
// src/pages/art/art.vue